import { apiUrl } from './tool'
import axios from 'axios'

const useMock = false

export function getLineMembersAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "10",
          "page_total": "1",
          "total": "1"
        },
        "data": [
          {
            "photo": "https://xxx",
            "name": "蔡友仁",
            "phone": "0922099195",
            "email": "",
            "bind_status": "1",  //-1封鎖,0未綁定,1綁定
            "create_time": "2021-03-25 15:09:44"
          }
        ]
      }
    })
  }
  const url = apiUrl('members', 'line')
  return axios.get(url, {params})
}

export function countLineMembersAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "total": 441
      }
    })
  }
  const url = apiUrl('members', 'line', 'total')
  return axios.get(url, {params})
}

export function exportLineMembersAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('members', 'line', 'download')
  return axios.post(url, data)
}

export function getMessengerMembersAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "paginate": {
          "page": "1",
          "limit": "1",
          "page_total": "6",
          "total": "6"
        },
        "data": [
          {
            "photo": "https://dentco.s3.us-east-2.amazonaws.com/asset/crm/avatar-unknow.png",
            "name": "",
            "phone": "0922099195",
            "email": "",
            "bind_status": "1",  //0未綁定,1綁定
            "create_time": "2023-04-11 16:33:14"
          }
        ]
      }
    })
  }
  const url = apiUrl('members', 'messenger')
  return axios.get(url, {params})
}

export function countMessengerMembersAPI(params) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "total": 441
      }
    })
  }
  const url = apiUrl('members', 'messenger', 'total')
  return axios.get(url, {params})
}

export function exportMessengerMembersAPI(data) {
  if (useMock) {
    return Promise.resolve({
      data: {
        "messages": "成功"
      }
    })
  }
  const url = apiUrl('members', 'messenger', 'download')
  return axios.post(url, data)
}

